module.exports = __webpack_public_path__ + "img/moblie-phone-md.6b754448.png";